import { ExtendedVue } from 'vue/types/vue'
import Pages from '@/components/parsers/Pages.vue'
import Groups from '@/components/parsers/Groups.vue'
import Elements from '@/components/parsers/Elements.vue'
import ItemsParser from '@/components/parsers/ItemsParser.vue'

export default {
  // eslint-disable-next-line
  getParser (content: Record<string, unknown>): ExtendedVue<any, any, any, any, any> {
    if (Object.prototype.hasOwnProperty.call(content, 'pages')) {
      return Pages
    } else if (Object.prototype.hasOwnProperty.call(content, 'groups')) {
      return Groups
    } else if (Object.prototype.hasOwnProperty.call(content, 'items')) {
      return ItemsParser
    } else {
      return Elements
    }
  }
}
